export interface S3ErrorResponse {
  statusCode: number | undefined;
  code: string | undefined;
  message: string | undefined;
}

export function parseS3ErrorResponse(statusCode: number | undefined, body: string): S3ErrorResponse {
  return {
    statusCode,
    code: /<Code>([^<]*)<\/Code>/.exec(body)?.[1],
    message: /<Message>([^<]*)<\/Message>/.exec(body)?.[1],
  };
}

/**
 * S3 answers 400 ExpiredToken once the session token that signed a URL has
 * expired, and 403 AccessDenied "Request has expired" once X-Amz-Expires has
 * passed. Either way a freshly signed URL for the same request will succeed.
 */
export function isExpiredSignedUrlResponse(response: S3ErrorResponse): boolean {
  if (response.statusCode === 400) {
    return response.code === 'ExpiredToken';
  }
  if (response.statusCode === 403) {
    return response.code === 'AccessDenied' && response.message === 'Request has expired';
  }
  return false;
}
